/**
 * Modal Store Module
 * Manages the state of modals in the application
 * @module store/modules/modal
 * @modals {Array} modals - Array of active modals
 * @modal { id, component, props, events, persistente } - Individual modal object
 *
 * `persistente: true` (opcional) hace que el modal no se cierre con un clic
 * afuera ni con Escape: para diálogos con un formulario a medio llenar o con
 * un proceso en curso. Se cierran solo desde sus propios botones.
 */

const modalStore = {
    state(){
        return {
            modals : [],
            idCounter: 1
        }
    },
    getters: {
        modals(state) {
            return state.modals;
        }
    },
    mutations: {
        OPEN_MODAL(state, { component, props = {}, events = {}, slots = {}, persistente = false }) {
            const id = state.idCounter++;
            state.modals.push({ id, component, props, events, slots, persistente });
            return id;
        },
        CLOSE_MODAL(state, id) {
            state.modals = state.modals.filter(modal => modal.id !== id);
        },
        CLOSE_TOP_MODAL(state) {
            state.modals.pop();
        }
    },

    actions: {
        openModal(context, { component, props = {}, events = {}, slots = {}, persistente = false }) {
            return context.commit('OPEN_MODAL', { component,  props, events, slots, persistente });
        },
        closeModal(context, id) {
            context.commit('CLOSE_MODAL', id);
        },
        closeTopModal(context) {
            context.commit('CLOSE_TOP_MODAL');
        },
    }
}

export default modalStore;